// src/config.js
// HorizonteCassaPyME — points to the same backend as horizontepyme-frontend

//---------------------------------------------------------------------------//
// PRODUCTION URLs (VPS)
//---------------------------------------------------------------------------//

export const NODE_BACKEND_API_URL = "https://horizontepyme.proyectoshorizontales.com/apitest";
export const NODE_BACKEND_SCH_URL = "https://horizontepyme.proyectoshorizontales.com/api/v3/search";
export const NODE_BACKEND_BRW_URL = "https://horizontepyme.proyectoshorizontales.com/api/v3/browse";
export const NODE_BACKEND_PRD_URL = "https://horizontepyme.proyectoshorizontales.com/api/v3/";
export const NODE_BACKEND_LOG_URL = "https://horizontepyme.proyectoshorizontales.com/apitest/api/login";
export const NODE_INVOICE_API_URL = "https://horizontepyme.proyectoshorizontales.com/apitest";
export const NODE_SUPPLIERS_API_URL = "https://horizontepyme.proyectoshorizontales.com/apitest";

export const NODE_FLASK_LOG_URL = "https://horizontepyme.proyectoshorizontales.com/flaskapi/auth/login";
export const FLASK_BACKEND_API_URL = "https://horizontepyme.proyectoshorizontales.com/flaskapi/fileupload/";
export const FLASK_CLIPBOARD_API_URL = "https://horizontepyme.proyectoshorizontales.com/flaskapi/generate-clipboard-data";

//---------------------------------------------------------------------------//
// CIA SERVER (LAN direct — uncomment for local testing)
//---------------------------------------------------------------------------//
/*
export const NODE_BACKEND_API_URL = "http://192.168.0.4:8096/apitest";
export const NODE_BACKEND_SCH_URL = "http://192.168.0.4:8096/api/v3/search";
export const NODE_BACKEND_PRD_URL = "http://192.168.0.4:8096/api/v3/";
export const NODE_BACKEND_LOG_URL = "http://192.168.0.4:8096/apitest/api/login";
export const NODE_INVOICE_API_URL = "http://192.168.0.4:8096/apitest";
export const NODE_SUPPLIERS_API_URL = "http://192.168.0.4:8096/apitest";

export const NODE_FLASK_LOG_URL = "http://192.168.0.4:5001/auth/login";
export const FLASK_BACKEND_API_URL = "http://192.168.0.4:5001/api/fileupload/";
export const FLASK_CLIPBOARD_API_URL = "http://192.168.0.4:5001/generate-clipboard-data";
*/

//---------------------------------------------------------------------------//
// INVOICE FEATURE FLAGS
// For a POS (Cassa) use case, Factura X (no AFIP registration) is the default.
// Enable AFIP invoice types here when the client organisation requires it.
//---------------------------------------------------------------------------//
export const INVOICE_FEATURES = {
    FACTURA_A_ENABLED: false,
    FACTURA_B_ENABLED: false,
    FACTURA_B_ALLOW_CLIENT_SEARCH: false,
    FACTURA_C_ENABLED: false,
    PRESUPUESTO_ENABLED: false,
    PRESUPUESTO_ALLOW_CLIENT_SEARCH: false,
    PRESUPUESTO_COPY_TO_CLIPBOARD: false,
    // Factura X — sale recorded in DB but NOT registered with AFIP. Default for Cassa POS.
    PRESUPUESTO_REGISTER_WITH_AFIP: false,
};
